import Service from "../DepartmentService";

function GetByDepartmentId(termId) {
    return Service.get(`FinalExamSchedule?termId=${termId}`);
}


const FinalExamScheduleService = {
    GetByDepartmentId
};

export default FinalExamScheduleService;
